export default __webpack_public_path__ + "static/media/haze.ce56be8c.jpg";